import * as React from 'react';
import Modal from '@amzn/awsui-components-react/polaris/modal';
import { Box, SpaceBetween, Button } from '@amzn/awsui-components-react';
import ReportFailure from './reportFailure';

type Props = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    inputVin: string;
    deviceInfo: any;
    setErrorMessage: (error: any) => void;
};

export default ({ visible, setVisible, inputVin, deviceInfo, setErrorMessage }: Props) => {
    const callback = (error: any) => {
        setErrorMessage(error);
        setVisible(false);
    };
    return (
        <Modal
            onDismiss={() => setVisible(false)}
            visible={visible}
            closeAriaLabel="Close modal"
            footer={
                <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button variant="link" onClick={() => setVisible(false)}>
                            Cancel
                        </Button>
                    </SpaceBetween>
                </Box>
            }
            header="Report Failure code to Amazon"
        >
            <h3>Please check LED Status Code and Report Below</h3>
            <ReportFailure callback={callback} inputVin={inputVin} deviceInfo={deviceInfo} />
        </Modal>
    );
};
